import { useEffect, useState } from "react";
import axios from "../../../axios";
import * as styled from "./ModalBlock.styled"

// Чи у вчителя звʼязок Speaksy замість Meet (VIDEO1) — питаємо один раз за сесію сторінки
let videoStatus;
const loadVideoStatus = () => {
  videoStatus = videoStatus || axios.get("video/status").then((res) => Boolean(res.data?.on)).catch(() => false);
  return videoStatus;
};

function ModalBlock({lesson, joinedLesson, cancelLesson}){
  const [speaksy, setSpeaksy] = useState(false);
  useEffect(() => {
    loadVideoStatus().then(setSpeaksy);
  }, []);

   if (!lesson) return null;
   // Пробні поки лишаються в Meet: у пробного учня інший кабінет
   const inSpeaksy = speaksy && lesson.type !== "Trial" && lesson.studentId;
   
  return (
    <>
      <styled.studentInfo>Тип урока:  {lesson.type} </styled.studentInfo>
      <styled.studentInfo>Ім'я:  {lesson.name} </styled.studentInfo>
      <styled.studentInfo>ID:  {lesson.studentId} </styled.studentInfo>
      <styled.studentInfo>Час: {lesson.time}</styled.studentInfo>
      <styled.studentInfo>Вікова група: {lesson.ageGroup}</styled.studentInfo>
      <styled.studentInfo>Рівень знань: {lesson.englishLevel}</styled.studentInfo>
      {inSpeaksy ? (
        <>
          <a href={`/call?student=${encodeURIComponent(lesson.studentId)}`} onClick={() => joinedLesson()}>
             <styled.JoinButton>Розпочати урок</styled.JoinButton>
          </a>
          {lesson.googleMeetLink && (
            <styled.MeetFallback href={lesson.googleMeetLink} target="_blank" rel="noopener noreferrer">запасний варіант — Google Meet</styled.MeetFallback>
          )}
        </>
      ) : (
        <a href={lesson.googleMeetLink} target="_blank" rel="noopener noreferrer" onClick={() => joinedLesson()}>
           <styled.JoinButton>Розпочати урок</styled.JoinButton>
        </a>
      )}
     {lesson.type !== "Trial" && <styled.CancelLesson onClick={() => cancelLesson(lesson.studentId)}>Скасувати урок</styled.CancelLesson>}
    </>
  )
};

export default ModalBlock;
